export default function RuleVersionBadge({ rules }) {
  const metadata = rules?.metadata;

  if (!metadata) {
    return null;
  }

  return (
    <aside className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 lg:max-w-xl">
      <p className="font-semibold">Sample fee rules · {metadata.version}</p>
      <p className="mt-1 leading-6">{metadata.warning}</p>
    </aside>
  );
}
